import { render, staticRenderFns } from "./TabSuggestion.vue?vue&type=template&id=2b24f20a&"
import script from "./TabSuggestion.vue?vue&type=script&lang=js&"
export * from "./TabSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports